import React, { Component } from 'react';
import './Feature.css';

export default function Feature(props) {
    return (
        <div className="feature">
            <img className="feature-img" src={props.src} alt="feature" />
            <h4 className="main-con">{props.cont}</h4>
            <h5 className="content">{props.content}</h5>
        </div>
    )
}